// z_template_folder/template_file.js
// TEMPLATE — copy this file into a numbered folder (0_global / 1_utils /
// 2_components / 3_pages), rename it, and replace this header with a one-line
// description of what the module does. See docs/JS_CONVENTIONS.md.

// Setup files (0_global, 1_utils) that add to the namespace open with a silent
// guard. Delete these two lines if the module doesn't touch window.NAT.
/* window.NAT = window.NAT || {};
window.NAT.utils = window.NAT.utils || {}; */

// init() is called automatically by main.js after the DOM is parsed. Put all
// DOM setup here. A page guard becomes an early return at the top.
/* export function init() {
	// Example consumer guard: bail (with a warning) if a dependency is missing.
	// if (!window.NAT?.utils?.scrollToElement) {
	// 	console.warn("[NAT] template_file.js: window.NAT.utils.scrollToElement missing — check load order");
	// 	return;
	// }

	const element = document.querySelector(".some-selector");
	if (!element) return;

	setupExample(element);
} */

// Named function declarations for module-level helpers.
/* function setupExample(element) {
	element.addEventListener("click", function (e) {
		// Regular function so `this` is the element. Use an arrow only when you
		// specifically want the enclosing scope's `this`.
		e.preventDefault();
		this.classList.toggle("is-active");
	});
}
 */
